// PrivacyPolicy.js
import React from "react";
import "../tearm&conditions/tearm&conditions.css";
import Header from "../../components/Navbar";
import Footer from "../../components/footer/footer";

function PrivacyPolicy() {
  return (
    <>
      <Header />

      <div className="max-w-5xl mx-auto p-6 text-gray-800 leading-relaxed" style={{marginTop:"44px"}}>
        {/* Title */}
        <h1 className="text-2xl font-bold text-center mb-2">
          PRIVACY POLICY
        </h1>

        <p className="text-center text-gray-600 mb-6">
          Effective Date: February 9, 2026
        </p>

        <div className="h-[75vh] overflow-y-auto pr-4 space-y-5">

          {/* Intro */}
          <p>
            <b>Twoffers – A Product of 2022842 Ontario Inc</b> (“Twoffers,” “we,”
            “our,” or “us”) is committed to protecting your privacy. This Privacy
            Policy explains how we collect, use, share, and safeguard personal data
            when you use our website https://www.twoffers.com, related services,
            mobile applications, and affiliated websites and apps (together, the
            “Sites” or “Platform”).
          </p>

          <p>
            This Policy also describes your rights regarding your personal data
            and how you can exercise them. Additional privacy notices may apply
            depending on your location or the services you use.
          </p>

          {/* 1 */}
          <h2 className="text-xl font-semibold mt-6">1. Information We Collect</h2>

          <p>We may collect personal data in the following ways:</p>

          <ul className="list-disc pl-6 space-y-3">

            <li>
              <b>(a) Information You Provide Directly</b>
              <ul className="list-decimal pl-8 mt-2 space-y-1">
                <li>Account registration: name, email, phone number, address, company or role.</li>
                <li>Platform activity: offers, purchases, messages, listing participation.</li>
                <li>Payment data: billing address, partial card data (processed securely by third-party providers).</li>
                <li>Communications: inquiries, support tickets, surveys, or feedback.</li>
                <li>Applications: employment, vendor, or partnership submissions.</li>
              </ul>
            </li>

            <li>
              <b>(b) Information from Third Parties</b>
              <ul className="list-decimal pl-8 mt-2 space-y-1">
                <li>Transaction partners such as sellers, brokers, or agents.</li>
                <li>Identity verification and fraud prevention providers.</li>
                <li>Marketing partners for relevant promotions.</li>
              </ul>
            </li>

            <li>
              <b>(c) Information Collected Automatically</b>
              <ul className="list-decimal pl-8 mt-2 space-y-1">
                <li>IP address, device ID, browser type, operating system.</li>
                <li>Pages visited, session duration, clicks.</li>
                <li>Referral data and search terms.</li>
              </ul>
            </li>
          </ul>

          <p>
            This information helps us improve Platform performance, security, and relevance.
          </p>

          {/* 2 */}
          <h2 className="text-xl font-semibold mt-6">2. How We Use Personal Data</h2>

          <ul className="list-disc pl-6 space-y-2">
            <li>Provide, manage, and improve our services and listings.</li>
            <li>Facilitate property transactions and verify payments.</li>
            <li>Customize your user experience.</li>
            <li>Respond to inquiries and provide customer support.</li>
            <li>Send service updates, confirmations, and notifications.</li>
            <li>Promote products or services (with opt-out option).</li>
            <li>Prevent fraud and verify identity.</li>
            <li>Fulfill legal obligations and enforce our Terms & Conditions.</li>
            <li>Analyze trends and optimize marketing.</li>
          </ul>

          {/* 3 */}
          <h2 className="text-xl font-semibold mt-6">3. How We Share Personal Data</h2>

          <ul className="list-disc pl-6 space-y-2">
            <li>Affiliates for operational and support purposes.</li>
            <li>Service providers such as payment processors, hosting, analytics, and marketing partners.</li>
            <li>Business partners or sellers when completing transactions.</li>
            <li>Legal or regulatory authorities when required by law.</li>
            <li>Transaction successors in mergers or acquisitions.</li>
            <li>Aggregated or de-identified data for analytics.</li>
          </ul>

          <p><b>We do not sell personal data.</b></p>

          {/* 4 */}
          <h2 className="text-xl font-semibold mt-6">4. Cookies & Tracking Technologies</h2>

          <ul className="list-disc pl-6 space-y-2">
            <li>Remember preferences and login sessions.</li>
            <li>Authenticate and secure access.</li>
            <li>Analyze traffic and optimize performance.</li>
            <li>Serve personalized content and ads.</li>
          </ul>

          <p>
            You can manage cookie preferences via browser settings. Blocking cookies
            may affect site functionality. The Platform does not currently respond
            to “Do Not Track” signals.
          </p>

          {/* 5 */}
          <h2 className="text-xl font-semibold mt-6">5. Data Transfers</h2>

          <p>
            Personal data may be processed outside your jurisdiction. Where required,
            we use legal safeguards such as Standard Contractual Clauses (SCCs) or
            equivalent protections.
          </p>

          {/* 6 */}
          <h2 className="text-xl font-semibold mt-6">6. Data Retention & Security</h2>

          <p>
            We retain data only as long as necessary to deliver services, comply with
            legal obligations, resolve disputes, and enforce policies. We apply
            industry-standard safeguards, but no system is 100% secure. Users are
            responsible for protecting their account credentials.
          </p>

          {/* 7 */}
          <h2 className="text-xl font-semibold mt-6">7. Children’s Privacy</h2>

          <p>
            The Platform is intended for users 18 years or older. We do not knowingly
            collect data from minors. If discovered, it will be deleted promptly.
          </p>

          {/* 8 */}
          <h2 className="text-xl font-semibold mt-6">8. Your Privacy Rights</h2>

          <ul className="list-disc pl-6 space-y-2">
            <li>Access your personal data.</li>
            <li>Correct inaccurate information.</li>
            <li>Request deletion (subject to exceptions).</li>
            <li>Request data portability.</li>
            <li>Restrict or object to certain processing.</li>
            <li>Opt-out of marketing communications.</li>
          </ul>

          <p className="mt-2">
            To exercise your rights, contact us at:
            <br />
            📧 support@twoffers.com
          </p>

          {/* 9 */}
          <h2 className="text-xl font-semibold mt-6">9. Links & Social Media</h2>

          <p>
            Our Sites may link to third-party platforms. We are not responsible for
            their privacy practices. Please review their policies before sharing data.
          </p>

          {/* 10 */}
          <h2 className="text-xl font-semibold mt-6">10. Changes to This Privacy Policy</h2>

          <p>
            We may revise this Policy periodically. Updates will be posted on this
            page with a new “Effective Date.” Please review regularly.
          </p>

          {/* 11 */}
          <h2 className="text-xl font-semibold mt-6">11. Contact Us</h2>

          <p>
            Twoffers – A Product of 2022842 Ontario Inc
            <br />
            📧 support@twoffers.com
            <br />
            📞 +1 (416) 821-7180
          </p>

        </div>
      </div>

      <Footer />
    </>
  );
}

export default PrivacyPolicy;